module.exports = "https://static.wagwalking.com/_next/static/images/banner-photo-desktop_2x-6f4a490a96a2ea5e714c4b331562245e.png";